const baseVendorCardClassName =
  'rounded-lg border p-4 transition-colors dark:border-gray-700';

export const getVendorCardClassName = (connected: boolean) =>
  `${baseVendorCardClassName} ${
    connected
      ? 'border-emerald-600 bg-emerald-600/10 dark:border-emerald-500 dark:bg-emerald-500/5'
      : 'border-gray-200 dark:bg-transparent'
  }`;
